export const isEmpty = (array) => {
    if (!(array instanceof Array)) return true

    return !array?.length;
}
